import {useContext} from 'react';
import {ConfigContext} from './config.provider';

export const useConfig = () => useContext(ConfigContext);
